import { render, staticRenderFns } from "./AddNewOnsite.vue?vue&type=template&id=0042f626"
import script from "./AddNewOnsite.vue?vue&type=script&lang=js"
export * from "./AddNewOnsite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports